import {Root as AtUiRoot} from "@opensoftpt/at-ui";
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {HelmetProvider} from "react-helmet-async";
import {ValidarDocumento} from "../pages";
import '../globals.scss';
import i18n from '../i18n';
import {I18nextProvider} from "react-i18next";

window.mount = function mount({ validarPageProps }) {

    ReactDOM.createRoot(
        document.getElementById('validar') as HTMLElement
    ).render(
        <React.StrictMode>
            <I18nextProvider i18n={i18n}>
                <AtUiRoot>
                    <HelmetProvider>
                        <ValidarDocumento {...validarPageProps!}/>
                    </HelmetProvider>
                </AtUiRoot>
            </I18nextProvider>
        </React.StrictMode>
    );
}